// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "计算机网络及应用",
        "tec": "赵丹",
        "week": "1-8周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "王艳",
        "week": "12周",
        "add": "实训楼F座203自控"
      }
    ],
    [
      {
        "sub": "模式识别",
        "tec": "刘宁",
        "week": "1-6周",
        "add": "实训楼F座302信息"
      },
      {
        "sub": "模式识别",
        "tec": "刘宁",
        "week": "7-11周",
        "add": "实训楼F座302信息"
      },
      {
        "sub": "劳动与创造",
        "tec": "王艳",
        "week": "12周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "模式识别",
        "tec": "刘宁",
        "week": "13-16周",
        "add": "实训楼F座302信息"
      }
    ],
    {
      "sub": "机器学习",
      "tec": "张悦",
      "week": "1-11,13周",
      "add": "教学楼B座121自控"
    },
    0,
    0
  ],
  "2": [
    [
      {
        "sub": "自动控制原理",
        "tec": "王艳",
        "week": "1-11,13-16周",
        "add": "教学楼B座119自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "王艳",
        "week": "12周",
        "add": "实训楼F座203自控"
      }
    ],
    {
      "sub": "劳动与创造",
      "tec": "王艳",
      "week": "12周",
      "add": "实训楼F座203自控"
    },
    {
      "sub": "最优化方法",
      "tec": "朱玥",
      "week": "1-10周",
      "add": "教学楼B座124自控"
    },
    {
      "sub": "就业创业指导",
      "tec": "许文利陈晓红",
      "week": "1-5周",
      "add": "实训楼F座102自控"
    },
    0
  ],
  "3": [
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "张洪涛",
        "week": "1-8周",
        "add": "教学楼A座117电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "张洪涛",
        "week": "9-11,13周",
        "add": "教学楼A座117电力"
      }
    ],
    [
      {
        "sub": "模式识别",
        "tec": "刘宁",
        "week": "1-6周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "模式识别",
        "tec": "刘宁",
        "week": "14-16周",
        "add": "实训楼F座203自控"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "机器学习",
      "tec": "张悦",
      "week": "1-11,13周",
      "add": "教学楼B座124自控"
    },
    [
      {
        "sub": "自动控制原理",
        "tec": "王艳",
        "week": "1-11单周",
        "add": "教学楼B座124自控"
      },
      {
        "sub": "自动控制原理",
        "tec": "王艳",
        "week": "14-16周",
        "add": "教学楼B座124自控"
      }
    ],
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "最优化方法",
      "tec": "朱玥",
      "week": "1-10周",
      "add": "教学楼B座124自控"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "张洪涛",
        "week": "1-8周",
        "add": "教学楼A座117电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "张洪涛",
        "week": "9-11,13周",
        "add": "教学楼A座117电力"
      }
    ],
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
